import React, {useEffect, useState} from 'react';
import Property from '@episerver/spa-core/Components/Property';
import {useInView} from 'react-intersection-observer';
import classNames from 'classnames';
import {isMobile} from 'react-device-detect';
import {getVideoLink, getBackgroundImageProps} from 'app/utilities/ImageProps';
import {gaEvent} from 'app/utilities/analytics/tracking';
import gaParams from 'app/utilities/analytics/constants';
import JoinCellcomTvBlockData from 'app/Models/Content/JoinCellcomTvBlockData';
import { setSelectedPackage } from '../SalePackagesBlock/salePackagesBlockSlice';
import { connect } from 'react-redux';
import { packageResponse } from '../../../utilities/SalePackagesHelper';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers.js';
import { gtag4 } from '../../../utilities/analytics/tracking';



type GaActionType = {
  category: string;
  eventType: string;
  eventParams: string | any[];
};

const gaAction = (param: GaActionType, params: string = null) =>
  param && gaEvent(param.category, param.eventType, params ?? param.eventParams);


const JoinCellcomTvComponent = (props) => {
  const [ref, inView, entry] = useInView();
  const [sticky, setSticky] = useState(false);
  const [stickyIn, setStickyIn] = useState(false);

  const {
    video,
    mobileVideo,
    mobileImage,
    image,
    salePage,
    salePageTitle,
    remark,
    appSalePage,
    appSalePageTitle,
    packageTV,
    packageApp
  } = props.iContent as JoinCellcomTvBlockData;


  useEffect(() => {
    if (!entry) return;
    if (!inView) {
      setSticky(true);
      setStickyIn(true);
    } else {
      setStickyIn(false);
      setTimeout(() => {
        setSticky(false);
      }, 300);
    }
  }, [inView, entry]);

  useEffect(() => {
    gaAction(gaParams.TV_NEW_SALE_PAGE_LOAD);
    gtag4({
      event: `TVAppProcess_Step1_SmartTvOrConverterPage`,
      step: '1',
      action:  'SmartTvOrConverterPage',
      funnel_name: 'Choose_Converter'
    });
  }, []);

  const buttonLink = (arrayItem:any,urlOfButton:any,nameButton:any) => {
    const containsTV = urlOfButton.expandedValue.url.includes("TV");
    const urlPage = urlOfButton?.expandedValue?.url || urlOfButton.value.url;
    if(arrayItem?.expandedValue != null){
      const selectedPackage = arrayItem?.expandedValue[0];
      const packageResponseObj = packageResponse(selectedPackage);
      props.setSelectedPackage(packageResponseObj);
    }
    if (urlPage) {
      prepareUrl(urlPage, props.context);
    };

    let namePackage;
    let funnel_name;
    if(containsTV){
      namePackage = 'OnlyTVProcess';
      funnel_name = '_Converter';
    }else {
      namePackage = 'TVAppProcess';
      funnel_name = '_SmartTV';
    }
    gtag4({
      event: `${namePackage}_Step1_ConverterButton`,
      step: '1',
      button: nameButton.value,
      action:  'ConverterButton',
      funnel_name: `Choose${funnel_name}`
    });
  };

  return (
    <div className={props.className}>
      <div className='join-cellcom-tv-component-wrapper'>
        <div className='title-wrapper'>
          <Property iContent={props.iContent} field='mainTitle' context={props.context} />
        </div>
        {video?.expandedValue?.url == null || mobileVideo?.expandedValue?.url == null ? (
          <div {...getBackgroundImageProps(isMobile ? mobileImage : image, props.context)} className='join-cellcom-image'></div>
        ) : (
          <video {...getVideoLink(isMobile ? mobileImage : image, props.context)} className='join-cellcom-video'></video>
        )}

        <div ref={ref} className='sticky-wrapper'>
          <div className={classNames('sticky-placeholder', {show: sticky})}></div>
          <div className={classNames('buttons-wrapper', {sticky: sticky, in: stickyIn})}>
            {salePage?.value && (
              <button
                className='btn-pink'
                onClick={() => buttonLink(packageTV,salePage,salePageTitle)}>
                {salePageTitle.value}
              </button>
            )}
            {appSalePage?.value && (
              <button
                className='btn-pink'
                onClick={() => buttonLink(packageApp,appSalePage,appSalePageTitle) }>
                {appSalePageTitle.value}
              </button>
            )}
            <div className='app-remark'>{remark.value}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state?: any) => {
  return {
    selectedPackage: state.SalePackagesBlock.selectedPackage,
  };
};

const mapDispatchToProps = { setSelectedPackage };

export default connect(mapStateToProps, mapDispatchToProps)(JoinCellcomTvComponent);
